// extracted by mini-css-extract-plugin
export default {"wrapper":"layout_wrapper__WV0Ei","main":"layout_main__x+TdP","content":"layout_content__2JAj2","innerWrapper":"layout_innerWrapper__OPhrX","navigation":"layout_navigation__KSByP"};